import { gql } from "lib/apolloClient";
import { aiFragment } from "./AITutorChatFragments";
import {
  toolResponseFragment,
  attachmentFragment,
} from "modules/CommonFragments";
import { assessmentToolFragment } from "modules/AssessmentTool/AssessmentToolFragment";

export const getAITutorConversationQuery = gql`
  query getAITutorConversation($id: ID!) {
    node(id: $id, type: AI_CONVERSATION) {
      ... on AiConversation {
        id
        entityType
        entitySubType
        metadata
        messages {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...aiMessageItem
            }
          }
        }
        attachments {
          ...attachmentItem
          modalityAttachment {
            id
            ... on ToddleDoc {
              id
              content: value
            }
            ... on ModalityFile {
              id
              content
              metadata
            }
          }
        }
        analysisToolEvaluation(filters: { userFilter: ALL }) {
          id
          toolId
          toolType
          toolResponses {
            ...toolResponseItem
          }
        }
      }
    }
  }
  ${aiFragment.aiMessage}
  ${toolResponseFragment.toolResponse}
  ${attachmentFragment.attachment}
`;

export const getAITutorLibraryAssessmentDetailsQuery = gql`
  query getAITutorLibraryAssessmentDetails($id: ID!, $uids: [String!]) {
    node(id: $id, type: ASSESSMENT) {
      id
      ... on Assessment {
        fields(uids: $uids) {
          id
          uid
          value
        }
        aiConversation {
          edges {
            node {
              id
              entityType
              entitySubType
              messages {
                edges {
                  node {
                    id
                    content
                    authorType
                  }
                }
              }
            }
          }
        }
        assessmentTools {
          edges {
            node {
              id
              assessmentToolType
              assessmentToolItem {
                id
                ... on Analysis {
                  ...aiAnalysisItem
                }
              }
            }
          }
        }
      }
    }
  }
  ${assessmentToolFragment.aiAnalysis}
`;

export const getMultiAttachmentsQuery = gql`
  query getMultiAttachments($ids: [ID!]) {
    multiNode(ids: $ids, type: ATTACHMENT) {
      ... on Attachment {
        id
        url
        name
        type
        title
        mimeType
        thumbUrl
        metadata
        toddleDoc {
          id
          value
        }
        modalityFile: modalityAttachment {
          id
          ... on ModalityFile {
            content
            metadata
            modalityType
          }
        }
      }
    }
  }
`;
